import AttachmentUrlConverter from "./AttachmentUrlConverter"

function makeConverter(editor) {
  const $ = editor.dom.$

  return (idx, elm) => {
    const $elm = $(elm)
    const filename = $elm.attr('data-filename')
    const url = $elm.attr('src')
    const width = $elm.attr('width')

    // p 바깥으로 빼는 처리 (ke에서는 p 안에 이미지 허용되지 않음)
    if (elm.parentElement.tagName.toLowerCase() === 'p') {
      const grandParent = elm.parentElement.parentElement;
      const parent = elm.parentElement;
      
      elm = parent.removeChild(elm);
      grandParent.insertBefore(elm, parent);
    }

    elm.outerHTML = `<figure data-ke-type="image" data-ke-style="alignCenter"><img src="${AttachmentUrlConverter.ufToTenthUrl(url)}" width="${width}"/><figcaption></figcaption></figure>`
  }

}

function makeConverterWithLink(editor) {
  const $ = editor.dom.$;

  return (idx, elm) => {
    const linkHref = elm.parentElement.getAttribute('href');
    const linkTarget = elm.parentElement.getAttribute('target');

    const $elm = $(elm)
    const filename = $elm.attr('data-filename')
    const url = $elm.attr('src')
    const width = $elm.attr('width')

    const grandParent = elm.parentElement.parentElement;

    // p 바깥으로 뺌
    if (grandParent && grandParent.tagName.toLowerCase() === 'p') {
      grandParent.removeChild(elm.parentElement);
      grandParent.parentElement.insertBefore(elm.parentElement, grandParent);
    }

    elm.parentElement.outerHTML = `<figure data-ke-type="image" data-ke-style="alignCenter" data-link="${linkHref}" data-link-newwindow="${linkTarget}">
<a href="${linkHref}" target="${linkTarget}"><img src="${AttachmentUrlConverter.ufToTenthUrl(url)}" width="${width}"/></a>
<figcaption></figcaption>
</figure>`
  }
}

const makeFileConverter = () => {
  const attachmentRawData = window.Config.attachmentRawData || [];

  const getTenthHash = (url) => {
    const splits = url.split('?')[0].split('/');
    return splits[splits.length - 1];
  }

  return (idx, elm) => {
    const anchorNode = elm.parentElement;
    const fileUrl = anchorNode.getAttribute('href');
    const tenthHash = getTenthHash(fileUrl);
    const attachmentData = attachmentRawData.find(attachment => attachment.name.indexOf(tenthHash) > -1);

    // db에 있는 파일목록에서 찾지 못한 경우
    if (!attachmentData) {
      return;
    }

    const fileSize = (attachmentData.size / 1024 / 1024).toFixed(2);

    elm.parentElement.outerHTML = `<figure data-ke-type="file" contenteditable="false" data-file-name="${attachmentData.label}"
data-file-size="${fileSize}" >
<a href="${fileUrl}">
  <div class="image"><br/></div>
  <div class="desc">
    <p class="filename">${attachmentData.label}</p>
    <p class="size">${fileSize}MB</p>
  </div>
</a>
</figure>`
  }
};

class DaumblogAttachmentConverter {
  static convertToEditor(editor, e) {
    // 수정일때만
    if (window.Config.post.id) {
      const $ = editor.dom.$

      const convertImageToImageComponent = makeConverter(editor)
      const convertImageWithLink = makeConverterWithLink(editor);
      const convertFile = makeFileConverter();

      $('p > img.txc-image', e.node).each(convertImageToImageComponent)
      $('p > img.tx-daum-image', e.node).each(convertImageToImageComponent)

      // center로 감싸져있는 경우도 있다....
      $('center > img.txc-image', e.node).each(convertImageToImageComponent)
      $('center > img.tx-daum-image', e.node).each(convertImageToImageComponent)

      // moreless(더보기) 의 경우 div 안에 있을 경우도 있음.
      $('div > img.txc-image', e.node).each(convertImageToImageComponent)
      $('div > img.tx-daum-image', e.node).each(convertImageToImageComponent)

      // 링크가 걸려있는 image
      $('a > img.txc-image', e.node).each(convertImageWithLink);
      $('a > img.tx-daum-image', e.node).each(convertImageWithLink);

      // 구에디터 첨부파일 변환
      $('a > img[src="//i1.daumcdn.net/icon/editor/p_etc_s.gif"]').each(convertFile);
      $('div > img[src="//i1.daumcdn.net/icon/editor/p_etc_s.gif"]').each(convertFile);
      $('center > img[src="//i1.daumcdn.net/icon/editor/p_etc_s.gif"]').each(convertFile);
    }
  }
}
export default DaumblogAttachmentConverter;
